import type { MargensEvolucaoResponse } from '@triade/contracts';
import { formatarContagem, formatarFracaoPercentual, formatarMoeda } from '@/lib/format';
import { BarraMargem, EixoMargem } from './barra-margem';
import { formatarMes } from './tipos';

/** Lucro medio por mes (barras na mesma escala de 30% do grafico de orcamentos) e tabela equivalente para leitores de tela. */
export function EvolucaoMensal({ dados }: { dados: MargensEvolucaoResponse }) {
  const pontos = dados.pontos;
  const primeiro = pontos[0];
  const ultimo = pontos[pontos.length - 1];
  const rotulo = primeiro && ultimo
    ? `Lucro médio por mês, de ${formatarMes(primeiro.mes)} a ${formatarMes(ultimo.mes)}: ${pontos.map((p) => `${formatarMes(p.mes)} ${formatarFracaoPercentual(p.exibicao.lucroMedio)}`).join('; ')}`
    : 'Sem meses';
  return (
    <>
      <div role="img" aria-label={rotulo} data-testid="grafico-evolucao" className="flex flex-col gap-2">
        {pontos.map((p) =>
          p.exibicao.lucroMedio && p.exibicao.barra ? (
            <BarraMargem key={p.mes} rotulo={formatarMes(p.mes)} lucro={p.exibicao.lucroMedio} barra={p.exibicao.barra} faixa={p.faixa} titulo={`${formatarContagem(p.orcamentos)} orçamentos · ${formatarMoeda(p.exibicao.receita)}`} />
          ) : (
            <div key={p.mes} className="grid grid-cols-[70px_minmax(0,1fr)_64px] gap-2.5 text-small text-ink-muted">
              <span className="tabular">{formatarMes(p.mes)}</span>
              <span>sem lucro calculado</span>
              <span />
            </div>
          ),
        )}
      </div>
      <EixoMargem maximo="0.3000" />
      <table className="sr-only">
        <caption>Evolução mensal do lucro médio</caption>
        <thead>
          <tr>
            <th scope="col">Mês</th>
            <th scope="col">Orçamentos</th>
            <th scope="col">Abaixo da meta</th>
            <th scope="col">Receita</th>
            <th scope="col">Lucro médio</th>
          </tr>
        </thead>
        <tbody>
          {pontos.map((p) => (
            <tr key={p.mes}>
              <th scope="row">{formatarMes(p.mes)}</th>
              <td>{formatarContagem(p.orcamentos)}</td>
              <td>{formatarContagem(p.abaixoDaMeta)}</td>
              <td>{formatarMoeda(p.exibicao.receita)}</td>
              <td>{formatarFracaoPercentual(p.exibicao.lucroMedio)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
